module.exports = __webpack_public_path__ + "static/assets/ebc2fa4e1e71773cc92275b58f140c39.png";